import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eBusNhaXeActionTypeIds, IBusNhaXeActionTypes } from "../../action-types/bus/IBusNhaXeActionTypes";
import { IBusNhaXePageStateModel } from "../../page-state-model/bus/IBusNhaXePageState";

const initialState: IBusNhaXePageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	bus_nhaxes: [],
	bus_nhaxe_editing: undefined,
	bus_nhaxe_deleting: undefined,
	bus_nhaxe_selected_ids: [],
	is_show_detail_modal: false,
	is_show_delete_confirm: false
}

export const busNhaXeReducer = (state: IBusNhaXePageStateModel = initialState, action: IBusNhaXeActionTypes): IBusNhaXePageStateModel => {
	switch (action.type) {
		case eBusNhaXeActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eBusNhaXeActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_nhaxes: action.payload || []
			}
		case eBusNhaXeActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_nhaxes: []
			}
		case eBusNhaXeActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				bus_nhaxe_editing: action.payload
			}
		case eBusNhaXeActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				bus_nhaxe_editing: undefined
			}
		case eBusNhaXeActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				bus_nhaxe_selected_ids: action.payload
			}
		case eBusNhaXeActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true,
				bus_nhaxe_deleting: action.payload
			}
		case eBusNhaXeActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false,
				bus_nhaxe_deleting: undefined
			}
		case eBusNhaXeActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eBusNhaXeActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
				bus_nhaxe_deleting: undefined
			}
		case eBusNhaXeActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		case eBusNhaXeActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eBusNhaXeActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success("Thay đổi dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				bus_nhaxe_editing: undefined
			}
		case eBusNhaXeActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		default:
			return state;
	}
}
